import {
  GET_COST_CENTER,
  CREATE_COST_CENTER,
  DELETE_COST_CENTER,
  UPDATE_COST_CENTER,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

// common success
export const CostCenterApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const CostCenterApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const CostCenter = () => ({
  type: GET_COST_CENTER,
});

export const CreateCostCenter = (data) => ({
  type: CREATE_COST_CENTER,
  payload: { data },
});

export const UpdateCostCenter = (id, data) => ({
  type: UPDATE_COST_CENTER,
  payload: { id, data },
});

export const DeleteCostCenter = (id) => ({
  type: DELETE_COST_CENTER,
  payload: { id },
});
